// extracted by mini-css-extract-plugin
export var bodyRow = "_is-d";
export var cardColumns = "_is-e";
export var ellipsesOverflow = "_is-2";
export var flatBottomCorners = "_is-3";
export var flatTopCorners = "_is-4";
export var headerActionsDropdown = "_is-f";
export var headerBottomRow = "_is-c";
export var headerTopRow = "_is-b";
export var orderDetailsWrapper = "_is-0";
export var orderInfoContainer = "_is-1";
export var productDetails = "_is-9";
export var productImage = "_is-5";
export var responsiveTable = "_is-8";
export var shipmentContainer = "_is-a";
export var tableBottomLeft = "_is-6";
export var tableBottomRight = "_is-7";
export var trackingLink = "_is-g";